<template>
  <div class="pa-4 grey--text">Settings coming soon.</div>
</template>

<script>
export default { name: 'IdeaSettings' }
</script>


